<template>
  <div v-if="showInterest" class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="formattedLabelText"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'digitalBrochureInterest'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @digitalBrochureInterest="submitDigitalBrochureInterest($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('digitalBrochureInterest', 'message')">
      Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import Manufacturer from '@/models/vehicle/manufacturer';
import GenericTouchpointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import ExtraData from '../../models/ExtraData';
import { tokenService } from '../../services/TokenService';

@Component({
  components: {
  touchpoint: GenericTouchpointComponent
  }
  })
export default class DigitalBrochureInterestComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Would you like manufacturerName to send a FREE brochure to your inbox? <span>*</span>' })
  public digitalBrochureInterestLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public options: Touchpoint[] = [
    new Touchpoint('true', 'Yes'),
    new Touchpoint('false', 'No')
  ];

  public get manufacturer(): Manufacturer | null {
    return this.$store.getters['vehicleModule/currentManufacturer'];
  }

  public get showInterest(): boolean {
    return this.manufacturer !== null && this.manufacturer.manufacturerId === 7;
  }

  public submitDigitalBrochureInterest(value: string) {
    const extraData = new ExtraData('digitalBrochureInterest', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    this.$store.dispatch('enquiryModule/submitBrochureChecked', value === 'true');
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public get formattedLabelText() {
    return tokenService.replaceToken(this.digitalBrochureInterestLabel);
  }
}
</script>
